(function () {
    "use strict";

    angular
        .module("UndergroundWebApp")
        .controller(
            "DeviceEventInfoModalController",
            DeviceEventInfoModalController
        );

    DeviceEventInfoModalController.$inject = ["$scope", "$filter", "event", '$windowInstance', '$translate'];

    function DeviceEventInfoModalController($scope, $filter, event, $windowInstance, $translate) {
        $scope.event = event;
        $scope.close = close;

        $scope.formatDate = function (date) {
            return $filter("date")(date, "dd.MM.yyyy HH:mm:ss");
        };

        function close() {
            $windowInstance.close();
        }
    }
})();
